import { Obj } from "../internal";
/**
 * Measurment Seqeunce
 * @class MeasurementSequence
 */
export class MeasureSequence extends Obj {
    constructor(scene, successcbf, failedcbf) {
        super();
        this.scene = null;
        this.successcbf = null;
        this.failedcbf = null;
        this.scene = scene;
        this.successcbf = successcbf;
        this.failedcbf = failedcbf;
    }
    destroy() {
        return;
    }
}
//# sourceMappingURL=measuresequence.js.map